"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeadingAndSubheading = exports.StyledAccordionChevron = exports.StyledAccordionHeader = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const react_1 = __importDefault(require("react"));
const theme_1 = __importDefault(require("../../components/styles/theme"));
exports.StyledAccordionHeader = styled_1.default.div `
	display: flex;
	justify-content: space-between;
	align-items: center;
	position: relative;
	margin: 0;
	color: ${theme_1.default.colours.neutral.darkest};
	cursor: pointer;

	.tbp-accordion__header {
		display: flex;
		align-items: center;
	}
`;
exports.StyledAccordionChevron = styled_1.default.div `
	min-width: ${(props) => `${props.width}px`};

	&:after {
		font-size: ${(props) => `${props.width}px`};
		content: ${(props) => props.open ? '"\\e902"' : '"\\e901"'};
		font-family: ${theme_1.default.typography.fonts.icons};
	}
`;
const HeadingAndSubheading = (props) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("span", { className: "accordion-header-text", style: Object.assign({ display: 'block', paddingTop: '20px', paddingBottom: '2px' }, theme_1.default.typography.a2) }, props.heading),
    react_1.default.createElement("span", { className: "", style: Object.assign({ display: 'block', paddingBottom: '20px' }, theme_1.default.typography.c2) }, props.subheading)));
exports.HeadingAndSubheading = HeadingAndSubheading;
//# sourceMappingURL=AccordionHeader.styled.js.map